module.exports = __webpack_public_path__ + "static/media/charts-720p.fc6a08b1.mp4";